<template>
	<div class="tabbar-wrap">
		<van-tabbar v-model="index" @change="switchTab" route>
			<van-tabbar-item to="/vascularNews/calendar">
				<img src="../../../assets/images/System/calendar_icon.png" alt="" v-if="index != 0">
				<img src="../../../assets/images/System/calendar_active_icon.png" alt="" v-if="index == 0">
				<span :style="{ 'color': index == 0 ? '#901D22' : '' }">会议日历</span>
			</van-tabbar-item>
			<!-- <van-tabbar-item to="/vascularNews/expert/zhuanjia">
				<img src="../../../assets/images/System/speaker_icon.png" alt="" v-if="index!=1">
				<img src="../../../assets/images/System/speaker_active_icon.png" alt="" v-if="index==1">
				<span :style="{'color':index==1?'#901D22':''}">讲者</span>
			</van-tabbar-item> -->
			<van-tabbar-item to="/vascularNews/wiki" v-if="!isCardiacDomain">
				<img src="../../../assets/images/System/wiki_icon.png" alt="" v-if="index != 1">
				<img src="../../../assets/images/System/wiki_active_icon.png" alt="" v-if="index == 1">
				<span :style="{ 'color': index == 1 ? '#901D22' : '' }">wiki</span>
			</van-tabbar-item>

			<van-tabbar-item to="/vascularNews" v-if="!isCardiacDomain">
				<img src="../../../assets/images/System/index_icon.png" alt="" v-if="index != 2">
				<img src="../../../assets/images/System/index_active_icon.png" alt="" v-if="index == 2">
				<span :style="{ 'color': index == 2 ? '#901D22' : '' }">首页</span>
			</van-tabbar-item>

			<!-- <van-tabbar-item to="/vascularNews/message">
				<img src="../../../assets/images/System/message_icon.png" alt="" v-if="index!=3">
				<img src="../../../assets/images/System/message_active_icon.png" alt="" v-if="index==3">
				<span :style="{'color':index==3?'#901D22':''}">消息</span>
			</van-tabbar-item> -->
			<van-tabbar-item :to="{ path: '/vascularNews/company', query: { meeting_id: this.$store.state.meeting_id } }" v-if="!isCardiacDomain"> 
				<img src="../../../assets/images/System/company_icon.png" alt="" v-if="index != 3">
				<img src="../../../assets/images/System/company_active_icon.png" alt="" v-if="index == 3">
				<span :style="{ 'color': index == 3 ? '#901D22' : '' }">企业</span>
			</van-tabbar-item>
			<van-tabbar-item to="/vascularNews/personal">
				<img src="../../../assets/images/System/me_icon.png" alt="" v-if="index != 4">
				<img src="../../../assets/images/System/me_active_icon.png" alt="" v-if="index == 4">
				<span :style="{ 'color': index == 4 ? '#901D22' : '' }">我的</span>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>
<script>
export default {
	props: {
		active: Number
	},
	data() {
		return {
			index: this.active ? this.active : 2,
			isPC: false,
			realmName: '',
			isCardiacDomain:false
		}
	},
	mounted() {
		this.isCardiacDomain = window.location.hostname === 'cardiacnews.cn' || window.location.hostname === 'www.cardiacnews.cn';
		if (this.ISPC()) {
			this.isPC = true;
		} else {
			this.isPC = false;
		}
		this.realmName = window.location.host;
		this.index = this.active;
		//   console.log(this.active,this.index,"mount");
	},
	activated() {
		this.index = this.active ? this.active : 2;
	},
	methods: {
		//切换tab
		switchTab(val) {
			this.index = val
			// console.log(this.index,"switch");
		},
		ISPC() {
			var userAgentInfo = navigator.userAgent;
			var Agents = ['Android', 'iPhone',
				'SymbianOS', 'Windows Phone',
				'iPad', 'iPod'
			];
			var flag = true;
			for (var i = 0; i < Agents.length; i++) {
				if (userAgentInfo.indexOf(Agents[i]) != -1) {
					flag = false;
					break;
				}
			}
			return flag;
		}



	}
}
</script>
<style lang="scss" scoped>
.tabbar-wrap {
	height: 75px;
	position: fixed;
	bottom: 0px;
	left: 0;
	width: 100%;

	a {
		width: 100%;
		display: inline-block;
		text-align: center;
		font-size: 14px;
		background: #fff;
	}
}

.van-tabbar {
	height: 55px;

	/*padding-bottom:5px;*/
	img {
		width: 25px;
		display: block;
		margin: 0 auto;
		margin-bottom: 5px;
	}

	span {
		font-size: 12px;
		margin-bottom: 5px;
		color: #999999;
		letter-spacing: 0.42px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Tabbar.vue